import React from 'react';
import s from './index.module.scss';

import { PaymentOffer } from './paymentOffer';
import { MainScreenV2 } from '../../components/everydoggyV2/mainScreenV2';
import { MainScreenV3 } from '../../components/everydoggyV5/mainScreenV3';
import { Timer } from '../../components/everydoggyV2/timer';
import { DiscountBlock } from '../../components/everydoggyV2/discountBlock';
import { PolycyBlockV2 } from '../../components/everydoggyV2/polycyBlockV2';
import { GetMyPlanBlock } from '../../components/everydoggyV5/getMyPlanBlock/getMyPlanBlock';
import { SupportBlock } from '../../components/everydoggyV2/supportBlock/supportBlock';
import { Footer } from '../../components/everydoggyV2/footer/footer';
import { Img } from '../../components/everydoggyV2/img/img';
import { Description } from '../../components/everydoggyV2/description/description';
import { InfoBlock } from '../../components/everydoggyV5/infoBlock/infoBlock';
import { MoneyBack } from '../../components/everydoggyV5/moneyBack/moneyBack';
import { IPaymentModalProduct } from '../../reduxStore/data/state';

import img1_png from './img/img1.png';
import img1_webp from './img/img1.webp';
import img1Dark_png from './img/img1Dark.jpg';
import img1Dark_webp from './img/img1Dark.webp';

type SpecialOfferScreenProps = {
  tariff: string;
  product: IPaymentModalProduct;
  darkTheme: boolean;
  showMoneyBack: boolean;
};

/** The discount (special-offer) paywall screen, shown once `isDiscount` flips. */
export const SpecialOfferScreen = ({ tariff, product, darkTheme, showMoneyBack }: SpecialOfferScreenProps) => {
  return (
    <div className={s.firstScreenWrapperV2}>
      <MainScreenV2 />
      <div className={s.timerWrapperV2}>
        <Timer tariff={tariff} />
      </div>
      <DiscountBlock />
      <div className={s.offerWrapper}>
        <PaymentOffer currentProduct={product.name} discount={true} tariff={tariff} />
      </div>
      <div className={s.polycyWrapper}>
        <PolycyBlockV2 />
      </div>
      <div className={s.getMyplanWrapper}>
        <GetMyPlanBlock special={true} tariff={tariff} secondScreen={false} />
      </div>

      {showMoneyBack ? <MoneyBack /> : null}

      <div className={s.imgWrapper}>
        <Img png={darkTheme ? img1Dark_png : img1_png} webp={darkTheme ? img1Dark_webp : img1_webp} />
      </div>
      <div style={{ marginTop: '8px' }}>
        <Description />
      </div>
      <div className={s.infoBlockWrappre}>
        <InfoBlock />
      </div>
      <div className={`${s.secondScreenWrapper}`} id="secondScreenWrapper">
        <MainScreenV3 />
        <div style={{ marginTop: '-42px' }}>
          <DiscountBlock />
        </div>
        <div className={s.offerWrapper}>
          <PaymentOffer currentProduct={product.name} discount={true} secondScreenWrapper={true} tariff={tariff} />
        </div>
        <div className={s.polycyWrapper}>
          <PolycyBlockV2 tariff={tariff} />
        </div>
        <div className={s.getMyplanWrapper}>
          <GetMyPlanBlock special={true} tariff={tariff} secondScreen={true} />
        </div>

        {showMoneyBack ? <MoneyBack style2={true} product={product} /> : null}

        <div style={{ marginBottom: '32px', marginTop: '20px' }} className={s.supportBlockWrapper}>
          <SupportBlock />
        </div>
        <Footer tariff={tariff} />
      </div>
    </div>
  );
};
